module.exports = __webpack_public_path__ + "static/media/om_faceshape_square_vector.4df8263d.svg";